import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import * as _ from "lodash";
import { Subscription } from "rxjs";
import { CdkDragDrop } from "@angular/cdk/drag-drop";
import { RoutesDragAndDropService } from "../../services/routes-drag-and-drop.service";
import { RoutePanelModel } from "../../../models/route-panel.model";
import { RoutesViewSettingsModel } from "../../../models/routes-view-settings.model";
import { RouteModel } from "../../../models/route.model";
import { ResourcesComponentStore } from "../../../../resources/angular/state/resources.store";
import { ResourceAllocationTimeWindowExtModel } from "../../../../resources/models/resource-allocation-time-window-ext.model";
import { RouteStatusEnum } from "../../../enums/route-status.enum";
import { RoutesTableListComponent } from "../routes-table-list/routes-table-list.component";

require('./routes-table-resource-view.scss');
@Component({
  standalone: false,
  selector: 'app-routes-table-resource-view',
  templateUrl: './routes-table-resource-view.html',
  providers: [ResourcesComponentStore],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoutesTableResourceViewComponent implements OnInit, OnChanges, OnDestroy {

  @Input() index: any;
  @Input() panel: RoutePanelModel;
  @Input() resource: ResourceAllocationTimeWindowExtModel;
  @Input() panels: RoutePanelModel[];
  @Input() resourcesDropListIds: string[];
  @Input() routesDropListIds?: string[];
  @Input() settings: RoutesViewSettingsModel;
  @Input() selectedServiceIds: string[];
  @Input() visibleIds: string[];

  @Output() onChangeResourceSequence = new EventEmitter<{ routeGroupId: string, orderedRouteIds: string[] }>();
  @Output() onUpdateRouteResource = new EventEmitter<{routeId: string, resource: ResourceAllocationTimeWindowExtModel}>();
  @Output() onAddServicesToResource = new EventEmitter<{resource: ResourceAllocationTimeWindowExtModel, serviceIds: string[]}>();
  @Output() onClose = new EventEmitter<any>();
  @Output() onDrillDownRoute = new EventEmitter<{ routeId: string, event: any }>();
  @Output() onToggleVisibleRoute = new EventEmitter<{ route: RouteModel, isVisible: boolean }>();
  @Output() onChangeRouteInfo = new EventEmitter<{route: any, event: any}>();

  public visibleKeys: { [key: string]: boolean } = {};
  public allPanelIds: string[];
  protected readonly routeStatusType = RouteStatusEnum;

  private resourceSubscription: Subscription;

  constructor(
    @Inject(ResourcesComponentStore) private resourcesStore: ResourcesComponentStore,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef,
    @Inject('leanPlanningService') private leanPlanningService,
    @Inject(RoutesDragAndDropService) private routesDragAndDropService: RoutesDragAndDropService) {
  }

  ngOnInit() {
    this.resourceSubscription = this.resourcesStore.resources$.subscribe((resources: ResourceAllocationTimeWindowExtModel[]) => {
      if (resources?.length) {
        this.resource = resources[0];
        this.cdr.detectChanges();
      }
    });

    if (this.resource) {
      this.resourcesStore.getResources({ids: this.resource.id});
    }
  }

  ngOnDestroy() {
    this.resourcesStore.unSubscribeAll();
    this.resourceSubscription?.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.panels || changes.resourcesDropListIds || changes.routesDropListIds) {
      const filteredPanels = _.filter(this.panels, (p) => {
        return p.id !== this.panel.id;
      });
      this.allPanelIds = _.concat(_.map(filteredPanels, 'id'), this.resourcesDropListIds, this.routesDropListIds || []);
    }
    if (changes.visibleIds) {
      this.visibleKeys = {};
      _.forEach(this.visibleIds, (id) => {
        this.visibleKeys[id] = true;
      });
      this.cdr.detectChanges();
    }
  }

  drop(event: CdkDragDrop<string[]>) {
    this.routesDragAndDropService.onDropResources(
      this.resource,
      event,
      this.selectedServiceIds
    ).then((result) => {
      if (result) {
        if (result.type === 'resequence') {
          this.onChangeResourceSequence.emit(result.data);
        } else if (result.type === 'update') {
          this.onUpdateRouteResource.emit(result.data);
        } else if (result.type === 'add') {
          this.onAddServicesToResource.emit(result.data);
        }
      }
    });
  }

  onToggleLockedRoute(event: {id: string, locked: boolean}) {
    this.leanPlanningService.editBlockedState(event.id, event.locked);
  }

  onDrillDownDblClick(route: RouteModel, event: any) {
    event.stopPropagation();
    this.onDrillDownRoute.emit({routeId: route.id, event: event});
  }

  public getTotalDuration(resource: ResourceAllocationTimeWindowExtModel): number {
    return resource.routes?.reduce((acc, route) => acc + route.totalTimeSec, 0) || 0;
  }

  public getTotalIncome(resource: ResourceAllocationTimeWindowExtModel): number {
    return resource.routes?.reduce((acc, route: any) => acc + (route.totals?.totalIncome || 0), 0) || 0;
  }
}
